import { render } from "./basedialog.vue?vue&type=template&id=c0b59e94"
import script from "./basedialog.vue?vue&type=script&lang=js"
export * from "./basedialog.vue?vue&type=script&lang=js"

import "./basedialog.vue?vue&type=style&index=0&id=c0b59e94&lang=css"

import exportComponent from "D:\\AAA_WORK\\os_FMS_sys_projectop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__